export const GET_LIVEWEATHERINFO_START = 'GET_LIVEWEATHERINFO_START';
export const GET_LIVEWEATHERINFO_SUCCESS = 'GET_LIVEWEATHERINFO_SUCCESS';
export const GET_LIVEWEATHERINFO_FAIL = 'GET_LIVEWEATHERINFO_FAIL';
export const SET_TEMPERATURE = 'SET_TEMPERATURE';
